import { makeProxyRequest } from '../utils/request';
import { rpc } from './helper';

export const podBasedGetEvaluationDetails = solutionSlug => {
  return makeProxyRequest(
    'get',
    rpc(`/pod_based/run_details/${solutionSlug}`),
    false
  );
};

export const podBasedRunCode = solutionSlug => {
  return makeProxyRequest(
    'post',
    rpc(`/run_code/pod_based/${solutionSlug}`),
    false
  );
};

export const getEvaluationLog = async logUrl => {
  return fetch(logUrl, { cache: 'no-store' });
};

export const getTestProjectDisabledSlugsApi = () =>
  makeProxyRequest('get', rpc('/pod_based/test_project/disabled_slugs'), false);
